export function buildHeaderNavigation({
	hasOrg = false,
	hasApplicantProfile = false,
	hasActiveApplicantProfile = false
} = {}) {
	return {
		primary: [
			{
				key: 'dashboard',
				to: '/dashboard',
				labelKey: 'link.dashboard',
				iconComponent: 'IconHome',
				showOnDesktop: true,
				showOnMobile: true,
				order: 1
			},
			{
				key: 'applications',
				to: '/applications/',
				labelKey: 'general.applications',
				iconComponent: 'IconFile',
				showOnDesktop: hasOrg || hasActiveApplicantProfile,
				showOnMobile: hasOrg || hasActiveApplicantProfile,
				order: 2
			},
			{
				key: 'talent-pool',
				to: '/talent-pool',
				labelKey: 'link.talent-pool',
				mobileLabelKey: hasOrg
					? 'link.talent-pool'
					: 'general.matches',
				iconComponent: 'IconUsers',
				showOnDesktop: hasOrg,
				showOnMobile: true,
				order: 3
			},
			{
				key: 'applicant-profile',
				to: '/applicant-profile',
				labelKey: 'general.profile',
				mobileLabelKey: 'general.profile',
				iconComponent: 'IconUser',
				showOnDesktop: hasApplicantProfile,
				showOnMobile: hasApplicantProfile,
				order: 3
			}
		]
	}
}
